/** */
import config from '../../../../config';

export const prepareCheckoutConfig = ({
  tenant,
  amount,
  currency,
  tx_reason = 'credits',
  payment_options = ''
}) => ({
  currency: currency.code,
  amount,
  public_key: config.fl_key,
  tx_ref: `agency_checkout:${tx_reason}:${tenant.id}:${amount}:${Date.now()}`,
  country: currency.country_code,
  payment_options:
    payment_options ||
    'card, banktransfer, ussd, internetbanking, account, ghanamobilemoney, mobilemoneyfranco, mobilemoneyuganda, mobilemoneyrwanda, mpesa',
  redirect_url: window.location.href,
  meta: {
    tenant_id: tenant.id,
    tenant_hash: tenant._id
  },
  customer: {
    email: tenant?.emails[0],
    phone_number: tenant.phone_number,
    name: tenant.name
  },
  callback: function (data) {
    console.log(data);
  },
  onclose: function () {
    // close modal
  },
  customizations: {
    title: 'Go-Mailer',
    description: 'Checkout',
    logo: 'https://files.go-mailer.com/images/a862b42dd12b1e62b4847f84e72714f8_logo.png'
  }
});
